import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EditorLink from 'lowcode/components/EditorLink';
import styles from './index.module.scss';

export default function SectionA2() {
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA2');

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            list: [t('item1_tag1'), t('item1_tag2'), t('item1_tag3')],
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750558148262/pc_Single%20Load%20or%20Area.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750558148454/m_Single%20Load%20or%20Area.png',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            list: [t('item2_tag1'), t('item2_tag2'), t('item2_tag3')],
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750558148639/pc_Multiple%20Loads%20or%20Areas.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750558228219/m_Multiple%20Loads%20or%20Areas.png',
        },
    ];

    const url = 'https://www.eaton.com/content/dam/eaton/technicaldocumentation/il/IL03801009Z2021_06.pdf';

    return (
        <div className={`page-sectionA2 ${styles.SectionA2}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA2}`}>
                <div className="flex-container">
                    {items.map((item, index) => (
                        <div className="flex-item" key={index}>
                            <EcoImg className="item-img" pc={item.pc} h5={item.h5} />
                            <div className="item-content">
                                <div className="item-title">{item.title}</div>
                                <div className="item-desc">{item.desc}</div>
                                <ul>
                                    {item.list.map((listItem, listIndex) => (
                                        <li key={listIndex}>{listItem}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="prodct-container">
                    <EcoImg className="item-img" pc="https://websiteoss.ecoflow.com/upload/image/1750927497271/img.png" />
                    <div className="item-content">
                        <div className="item-title">{t('item3_title')}</div>
                        <div className="item-desc">{t('item3_desc')}</div>
                        <div className="note">{t('item3_tip')}</div>
                        <EditorLink
                            className="link-to-page"
                            href={url}
                            target="_blank"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'jump_button',
                                position: 'Inpage',
                                button_name: t('item_text'),
                                url,
                            }}
                        >
                            {t('item_text')}
                        </EditorLink>
                    </div>
                </div>
            </div>
        </div>
    );
}
